import { render, staticRenderFns } from "./VipDetail.vue?vue&type=template&id=ed0c1046&"
import script from "./VipDetail.vue?vue&type=script&lang=js&"
export * from "./VipDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports